export default __webpack_public_path__ + "static/media/footer-br.31b44786.png";